'use strict';

import { module } from '../../app';

module.service('ageHelper', [ 'techpadConfig', function (techpadConfig) {
  
  let self = this;

  self.getAgeFromBirthDate = function (birthDate) {

    let today = new Date();
    
    let age = today.getFullYear() - birthDate.getFullYear();
    
    const monthDifference = today.getMonth() - birthDate.getMonth();
    
    const shouldSubtractAge = monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate());

    if (shouldSubtractAge) {
      age--;
    }

    return age;
  };

  
}]);



// WEBPACK FOOTER //
// ./src/scripts/services/helpers/ageHelper.js